/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyMetadataDto } from './CompanyMetadataDto';
import {
    CompanyMetadataDtoFromJSON,
    CompanyMetadataDtoFromJSONTyped,
    CompanyMetadataDtoToJSON,
    CompanyMetadataDtoToJSONTyped,
} from './CompanyMetadataDto';

/**
 * 
 * @export
 * @interface CompanyMetadataResponseDto
 */
export interface CompanyMetadataResponseDto {
    /**
     * 
     * @type {{ [key: string]: CompanyMetadataDto; }}
     * @memberof CompanyMetadataResponseDto
     */
    companies?: { [key: string]: CompanyMetadataDto; } | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyMetadataResponseDto
     */
    totalCompanies?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyMetadataResponseDto
     */
    totalOrders?: number;
}

/**
 * Check if a given object implements the CompanyMetadataResponseDto interface.
 */
export function instanceOfCompanyMetadataResponseDto(value: object): value is CompanyMetadataResponseDto {
    return true;
}

export function CompanyMetadataResponseDtoFromJSON(json: any): CompanyMetadataResponseDto {
    return CompanyMetadataResponseDtoFromJSONTyped(json, false);
}

export function CompanyMetadataResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyMetadataResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'companies': json['companies'] == null ? undefined : (mapValues(json['companies'], CompanyMetadataDtoFromJSON)),
        'totalCompanies': json['totalCompanies'] == null ? undefined : json['totalCompanies'],
        'totalOrders': json['totalOrders'] == null ? undefined : json['totalOrders'],
    };
}

export function CompanyMetadataResponseDtoToJSON(json: any): CompanyMetadataResponseDto {
    return CompanyMetadataResponseDtoToJSONTyped(json, false);
}

export function CompanyMetadataResponseDtoToJSONTyped(value?: CompanyMetadataResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companies': value['companies'] == null ? undefined : (mapValues(value['companies'], CompanyMetadataDtoToJSON)),
        'totalCompanies': value['totalCompanies'],
        'totalOrders': value['totalOrders'],
    };
}

